export const format = (fileName) => fileName.match(/\.[0-9a-z]+$/i)[0]
